@if (baseValueRows.length > 0) {
    <table mat-table [dataSource]="baseValueRows">
        <ng-container matColumnDef="name">
            <th mat-header-cell *matHeaderCellDef i18n="@@model.baseValue.name">Bezeichnung</th>
            <td mat-cell *matCellDef="let baseValueRow">
                <span>{{baseValueRow.name}}</span>
            </td>
        </ng-container>
        <ng-container matColumnDef="value">
            <th mat-header-cell *matHeaderCellDef class="col-value" i18n="@@model.baseValue.value">Wert</th>
            <td mat-cell *matCellDef="let baseValueRow" class="col-value">
                <span>
                    <app-rendered-value [value]="baseValueRow.value"
                                        [unit]="baseValueRow.unit" />
                </span>
            </td>
        </ng-container>

        <tr mat-header-row *matHeaderRowDef="columns"></tr>
        <tr mat-row *matRowDef="let row; columns: columns;"></tr>
    </table>
}
